import { render, staticRenderFns } from "./ListadoCategoriasEquivalentes.vue?vue&type=template&id=716d0247"
import script from "./ListadoCategoriasEquivalentes.vue?vue&type=script&lang=js"
export * from "./ListadoCategoriasEquivalentes.vue?vue&type=script&lang=js"
import style0 from "./ListadoCategoriasEquivalentes.vue?vue&type=style&index=0&id=716d0247&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports